import { useContext, useState, useEffect } from "react";
import NodeContext from "../../utils/NodeContext";

export default function SidebarFocus({ isOpen, setSelectedNode }) {
	const { primaryNode } = useContext(NodeContext);
	const [allChecked, setAllChecked] = useState(false);
	const [checked, setChecked] = useState([]);

	useEffect(() => {
		setSelectedNode((prevState) => ({ ...prevState, filters: checked }));
	}, [checked, setSelectedNode]);

	const toggleCheckbox = (e) => {
		const nodeID = +e.target.value; // + casts to number

		if (checked.includes(nodeID)) {
			setChecked(checked.filter((item) => item !== nodeID));

			//Check if not all checked and set allChecked to false
			if (checked.length - 1 !== primaryNode.children.length) {
				setAllChecked(false);
			}
		} else {
			setChecked([...checked, nodeID]);

			//Check if all will be checked and set allChecked accordingly
			if (checked.length === primaryNode.children.length - 1) {
				setAllChecked(true);
			}
		}
	};

	const toggleAllCheckboxes = () => {
		if (allChecked) {
			setChecked([]);
		} else {
			setChecked(primaryNode.children.map((item) => item.term_id));
		}
		setAllChecked(!allChecked);
	};

	return (
		<div className={isOpen ? "block" : "hidden"}>
			<div className="p-6">
				<span className="text-sm uppercase font-semibold">Areas of Focus</span>
				{primaryNode.name ? (
					<h3 className="text-4xl font-light mb-4">{primaryNode.name}</h3>
				) : null}
				<ul className="my-6 py-6 px-0">
					{primaryNode.children.length > 0 ? (
						<li className="text-sm uppercase font-bold my-3">
							<button
								onClick={(e) => toggleAllCheckboxes()}
								className="text-white"
							>
								{" "}
								{allChecked ? "Deselect all" : "Select All"}
							</button>
						</li>
					) : null}
					{primaryNode.children
						? primaryNode.children.map((child, index) => {
							return (
								<li key={index} className="mb-2">
									<input
										name="focus[]"
										id={child.term_id}
										className="node__checkbox"
										type="checkbox"
										value={child.term_id}
										onChange={(e) => toggleCheckbox(e)}
										checked={checked.includes(child.term_id)}
									/>
									<label className="node__label" htmlFor={child.term_id}>
										<span>{child.name}</span>
									</label>
								</li>
							);
						})
						: null}
				</ul>
			</div>
		</div>
	);
}
